// §4.4 partial — admin/anomalies routes.
// Composer auto-collects this into routes.generated.ts.
import type { RouteObject } from "react-router-dom";

const routes: RouteObject[] = [];

export default routes;
